{{#with attributes}}
<{{#if decorations.isButton}}button {{#if button-styles}}class="btn {{obj_values_to_string button-styles}}"{{/if}}
{{else}}a
{{#if locale-span.styles}}class="{{obj_values_to_string locale-span.styles}}"{{/if}}
href="{{#if action.destination.path}}{{action.destination.path}}{{/if}}"
{{/if}}
id="link-atom-{{../cid}}"
{{#if decorations.tooltip}}data-region="atom-tooltip-{{../cid}}"{{/if}}
>
{{~#if decorations.beforeIcon.icon-fontawesome.icon~}}
<span class="m-inline-{{#unless decorations.isButton}}x{{/unless}}xs inline-atom iconBefore-{{../cid}}"></span>
{{~/if~}}
{{~>localeSpan props=locale-span ~}}
{{~#if decorations.afterIcon.icon-fontawesome.icon~}}
<span class="inline-atom iconAfter-{{../cid}} m-inline-left-{{#unless decorations.isButton}}x{{/unless}}xs"></span>
{{~/if~}}
{{~#if sr-text.locale-key~}}
  <span class="screen-reader-content">{{t sr-text.locale-key}}</span>
{{~/if~}}
</{{#if decorations.isButton}}button{{else}}a{{/if}}>
{{/with}}
